/* ++++++++++ --------------- IMPORT --------------- ++++++++++ */
import { settings } from 'data/embedsettings';



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// this will be used to gauge the amount of time a user has spent for a given event fired by tracking
export default (embedState, contentStatus, addon) => {
	// transpiled settings starter object
	let transpiledObject = Object.assign({}, settings);
	// SITE
	transpiledObject.site.uuid = embedState.siteUUID;
	transpiledObject.site.url = embedState.siteURL === null ? '' : embedState.siteURL; // IF THIS IS NULL IT WILL BREAK THE WHOLE DAMN THING GRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR

	// EMBED
	transpiledObject.embed.uuid = embedState.embedUUID;
	transpiledObject.embed.name = embedState.embedName;
	transpiledObject.embed.location = embedState.location;
	transpiledObject.embed.brandColor = embedState.brandColor;

		// ADS
		let adStringValue = 'REGULAR'; // REGULAR, OVERLAY_TOP_AD, OVERLAY_BOTTOM_AD, BOTH_OVERLAY_ADS
		if (embedState.ads.desktop.ad1 && embedState.ads.desktop.ad2 && !embedState.ads.desktop.overlay) { adStringValue = 'REGULAR' }
		else if (!embedState.ads.desktop.ad1 && !embedState.ads.desktop.ad2 && !embedState.ads.desktop.overlay) { adStringValue = 'NONE' }
		else if (embedState.ads.desktop.ad1 && !embedState.ads.desktop.ad2 && !embedState.ads.desktop.overlay) { adStringValue = 'ONLY_TOP_AD' }
		else if (!embedState.ads.desktop.ad1 && embedState.ads.desktop.ad2 && !embedState.ads.desktop.overlay) { adStringValue = 'ONLY_BOTTOM_AD' }
		else if (!embedState.ads.desktop.ad1 && !embedState.ads.desktop.ad2 && embedState.ads.desktop.overlay) { adStringValue = 'BOTH_OVERLAY_ADS' }
		else if (embedState.ads.desktop.ad1 && embedState.ads.desktop.ad2 && embedState.ads.desktop.overlay) { adStringValue = 'BOTH_OVERLAY_ADS' }
		else if (!embedState.ads.desktop.ad1 && embedState.ads.desktop.ad2 && embedState.ads.desktop.overlay) { adStringValue = 'OVERLAY_TOP_AD' }
		else if (embedState.ads.desktop.ad1 && !embedState.ads.desktop.ad2 && embedState.ads.desktop.overlay) { adStringValue = 'OVERLAY_BOTTOM_AD' }
		else { adStringValue = 'REGULAR' }
		transpiledObject.embed.ads.display.desktop = adStringValue;
		transpiledObject.embed.ads.display.mobile = adStringValue;

		// REWARDS
		transpiledObject.embed.rewards.enabled = false;

		// MARKET RESEARCH / PROFILING QUESTIONS
		let mixedContent,
			// profilingQuestionsContent,
			userDataCollection;
		transpiledObject.embed.content.forEach(content => {
			if (content.type === 'mixed') { mixedContent = content; }
			if (content.type === 'userDataCollection') { userDataCollection = content; }
			// if (content.type === 'questionnaire') { profilingQuestionsContent = content; }
		});
		//Check the addons first!
		if(addon === 'EMAIL_COLLECTION' || (!!contentStatus.noLiveContents && !!embedState.showUserDataCollection)){
			userDataCollection.queuePosition = 0;
			mixedContent.queuePosition = null;
		}else if(!embedState.showUserDataCollection){
			mixedContent.queuePosition = 0;
			mixedContent.injectables.forEach(injectable => {
				if(injectable.id === 'udc-01'){
					injectable.injectAtFrame = null;
				}
			});
			userDataCollection.queuePosition = null;
		}
		if(!addon && !!embedState.showUserDataCollection && !contentStatus.noLiveContents){
			mixedContent.queuePosition = 0;
			userDataCollection.queuePosition = null;
			mixedContent.injectables.forEach(injectable => {
				if(injectable.id === 'udc-01'){
					injectable.injectAtFrame = contentStatus.addons.userDataCollection.queuePosition.value - 1;
				}
			})
		}

		// PARTNER LOGO
		transpiledObject.embed.elements.partnerLogo.src = embedState.partnerLogo.src;
		transpiledObject.embed.elements.partnerLogo.url = embedState.partnerLogo.url;
		mixedContent.elements.header.partnerLogo.visible = embedState.showPartnerLogo;

		// INSTICATOR BRANDING
		transpiledObject.embed.enableInsticatorBranding = embedState.showInsticatorBranding;
	// return transpiled object
	return transpiledObject;
};

// both MR and PQ on
// if (!contentStatus.noLiveContents && embedState.revenue.profilingQuestions && embedState.revenue.marketResearch) {
// 	profilingQuestionsContent.queuePosition = 1;
// 	marketResearchContent.queuePosition = 2;
// }
// // PQ only
// else if (!contentStatus.noLiveContents &&  embedState.revenue.profilingQuestions && !embedState.revenue.marketResearch) {
// 	profilingQuestionsContent.queuePosition = 1;
// 	marketResearchContent.queuePosition = null;
// }
// // MR only
// else if (!contentStatus.noLiveContents && !embedState.revenue.profilingQuestions && embedState.revenue.marketResearch) {
// 	profilingQuestionsContent.queuePosition = null;
// 	marketResearchContent.queuePosition = 1;
// }
// //no content both MR and PQ on
// else if (contentStatus.noLiveContents && embedState.revenue.profilingQuestions && embedState.revenue.marketResearch) {
//     mixedContent.queuePosition = null;
// profilingQuestionsContent.queuePosition = 0;
// marketResearchContent.queuePosition = 1;
// }
// //no content PQ only
// else if (contentStatus.noLiveContents &&  embedState.revenue.profilingQuestions && !embedState.revenue.marketResearch) {
//     mixedContent.queuePosition = null;
// profilingQuestionsContent.queuePosition = 0;
// marketResearchContent.queuePosition = null;
// }
// //no content MR only
// else if (contentStatus.noLiveContents && !embedState.revenue.profilingQuestions && embedState.revenue.marketResearch) {
//     mixedContent.queuePosition = null;
// profilingQuestionsContent.queuePosition = null;
// marketResearchContent.queuePosition = 0;
// 	}
// // none
// else {
// 	profilingQuestionsContent.queuePosition = null;
// 	marketResearchContent.queuePosition = null;
// }

